<template>
  <div>
    <div class="header-container">
      <div class="pop_title" v-if="popEdit">Free Shipping on All Orders
        <!-- <img class="close_icon" v-if="popEdit" src="https://shopvidi.oss-cn-beijing.aliyuncs.com/homepage-img/topbar_close%402x.jpg" alt="" @click="closeHandel()"> -->
      </div>
      <!--顶部导航-->
      <head-com @getList="getListHandle" ref="head" @wapShow="wapShow" :isFirstOrder="isFirstOrder" :is-show-nt="isShowNtInfo"></head-com>
      <!--导航开始-->
      <nav-com ref="meau" @showLoginUp="showLoginUp"  @loginHandle="loginHandle" @showLogin="showLogin" @showLoginHandle="showLoginHandle" :isFirstOrder="isFirstOrder" :is-show-nt="isShowNtInfo"></nav-com>
    </div>
  </div>
</template>

<script>
import HeadCom from '../components/head.vue'
import NavCom from '../components/nav.vue'
import { getAction } from '@/api/manage.js'

export default {
  components: { HeadCom, NavCom },
  props: {
    getList: {
      type: Function,
      default: null
    },
    gourlHandle: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      popEdit: true,
      isFirstOrder: false, // 是否首单
      isShowNtInfo: false // 使用显示nt信息
    }
  },
  computed: {
    isDetailMod() {
      const isMod = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return this.$route.name === 'detail' && isMod
    }
  },
  created() {
    // add by cpgu 2023/02/06 begin
    if (this.login) {
      // 检查首单
      this.checkIsFirstOrder()
      // 解析url，显示nt信息
      this.parseNtStatus()
    }
    // end by cpgu

    // // TODO 解决IOS14版本的不刷新问题。重新刷新，然后将localstorgaeshowApp清空
    // if (localStorage.getItem('showApp') !== null) {
    //   if (parseInt(localStorage.getItem('showApp')) === 1) {
    //     this.$nextTick(() => {
    //       this.$refs.meau.showMenuAction()
    //       localStorage.removeItem('showApp')
    //     })
    //   }
    // }
  },
  methods: {
    closeHandel() {
      this.popEdit = false
    },
    wapShow() {
      // var version = this.checkPlatform()
      // if (version !== null && version !== undefined && version !== '') {
      //   let versionArray = []
      //   versionArray = version.split('--')
      //   if (versionArray.length === 2) {
      //     if (versionArray[0] === 'IOS' && parseInt(versionArray[1]) === 15) {
      //       localStorage.setItem('showApp', 1)
      //       location.reload()
      //     }
      //   }
      // }
      this.$refs.meau.showMenuAction()
    },
    showLogin() {
      this.$refs.head.showInginPop('login')
    },
    loginHandle(type) {
      this.$refs.head.loginHandle(type)
    },
    showLoginUp() {
      this.$refs.head.showInginPop('register')
    },
    showLoginHandle() {
      this.$refs.head.showLoginHandle()
    },
    getListHandle(data) {
      this.$emit('getList', data)
    },
    parseNtStatus() {
      if (window.location.href.indexOf('show-nt') > 0) {
        localStorage.setItem('show_nt', '1')
      }
      this.isShowNtInfo = !!localStorage.getItem('show_nt')
    },
    async checkIsFirstOrder() {
      let res = await getAction(`/order/check/platform/first-order`)
      this.isFirstOrder = res.result
    }
    // 手机端判断各个平台浏览器及操作系统平台
    // checkPlatform() {
    //   var ua = navigator.userAgent.toLowerCase()
    //   if (/android/i.test(navigator.userAgent)) {
    //     var test = /android\s([\w.]+)/// IE
    //     var match = test.exec(ua)
    //     // 这是Android平台下浏览器
    //     // document.write('This is Android ' + match[1] + ' browser.')
    //     var version = match[1].split('.')[0]
    //     console.log(version)
    //     return 'Andriod--' + version
    //   }
    //   if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    //     var testIOS = /os\s([\w_]+)/// IE
    //     var matchIOS = testIOS.exec(ua)
    //     var versionIOS = matchIOS[1].split('_')[0]
    //     console.log(versionIOS)
    //     return 'IOS--' + versionIOS
    //     // 这是iOS平台下浏览器
    //     // document.write('This is iOS ' + versionIOS + ' browser.')
    //   }
    //   // if (/MicroMessenger/i.test(navigator.userAgent)) {
    //   //   // 这是微信平台下浏览器
    //   //   // document.write("This is MicroMessenger'browser.")
    //   // }
    // }

  }
}
</script>

<style lang="less" scoped>
.header-container {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99;
  width: 100%;
  background-color: #fff;
}
.pop_title{
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #F3E93D;
  color: #262B2F;
  font-size: 14px;
  font-family: Graphik;
  font-weight: 400;
  .close_icon{
    width: 12px;
    height: 12px;
    position: absolute;
    right: 20px;
    top: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/components/floatHeader.vue